import { useState, useMemo, useEffect } from 'react';
import osmtogeojson from 'osmtogeojson';
import { Container, Flex, styled } from "../styled-system/jsx";
import { visuallyHidden } from '../styled-system/patterns';
import { LuDownload, LuSearch } from "react-icons/lu";
import toast, { Toaster } from 'react-hot-toast';

const UIC_OPTIONS = [{ uic: '87271494', name: 'Aéroport Charles de Gaulle 2 TGV' },
{ uic: '87319012', name: 'Aix-en-Provence TGV' },
{ uic: '87484006', name: 'Angers Saint-Laud' },
{ uic: '87318964', name: 'Avignon TGV' },
{ uic: '87581009', name: 'Bordeaux Saint-Jean' },
{ uic: '87757625', name: 'Cannes' },
{ uic: '87713040', name: 'Dijon' },
{ uic: '87747006', name: 'Grenoble' },
{ uic: '87223263', name: 'Lille Europe' },
{ uic: '87286005', name: 'Lille Flandres' },
{ uic: '87723197', name: 'Lyon Part Dieu' },
{ uic: '87722025', name: 'Lyon Perrache' },
{ uic: '87111849', name: 'Marne-la-Vallée Chessy' },
{ uic: '87751008', name: 'Marseille Saint-Charles' },
{ uic: '87192039', name: 'Metz' },
{ uic: '87773002', name: 'Montpellier Saint-Roch' },
{ uic: '87182063', name: 'Mulhouse' },
{ uic: '87141002', name: 'Nancy' },
{ uic: '87481002', name: 'Nantes' },
{ uic: '87756056', name: 'Nice' },
{ uic: '87775007', name: 'Nîmes' },
{ uic: '87547000', name: 'Paris Austerlitz' },
{ uic: '87113001', name: 'Paris Est' },
{ uic: '87686006', name: 'Paris Gare de Lyon Hall 1 & 2' },
{ uic: '87271007', name: 'Paris Gare du Nord' },
{ uic: '87391003', name: 'Paris Montparnasse Hall 1 & 2' },
{ uic: '87384008', name: 'Paris Saint-Lazare' },
{ uic: '87471003', name: 'Rennes' },
{ uic: '87411017', name: 'Rouen Rive Droite' },
{ uic: '87212027', name: 'Strasbourg' },
{ uic: '87611004', name: 'Toulouse Matabiau' },
{ uic: '87444877', name: 'Cherbourg' },
{ uic: '87734004', name: 'Clermont-Ferrand' },
{ uic: '87473207', name: 'Guingamp' },
{ uic: '87164798', name: 'La Plaine Stade de France - Saint-Denis – Aubervilliers' },
{ uic: '87478404', name: 'Laval' },
{ uic: '87413013', name: 'Le Havre' },
{ uic: '87476002', name: 'Lorient Bretagne Sud' },
{ uic: '87764001', name: 'Montélimar' },
{ uic: '87474338', name: 'Morlaix' },
{ uic: '87575001', name: 'Poitiers' },
{ uic: '87471300', name: 'Redon' },
{ uic: '87473009', name: 'Saint-Brieuc' },
{ uic: '87726000', name: 'Saint-Étienne Châteaucreux' },
{ uic: '87481705', name: 'Saint-Nazaire' },
{ uic: '87164780', name: 'Stade de France Saint-Denis' },
{ uic: '87571000', name: 'Tours' },
{ uic: '87271460', name: 'Aéroport Charles de Gaulle 1' },
{ uic: '87393058', name: 'Champ de Mars Tour Eiffel' },
{ uic: '87382218', name: 'La Défense' },
{ uic: '87271395', name: 'Le Bourget' },
{
    uic: '87547307', name: 'Musée d\'Orsay'},
{ uic: '87547315', name: 'Saint-Michel Notre-Dame' },
{ uic: '87393157', name: 'Versailles Château Rive Gauche' },
{ uic: '87313874', name: 'Amiens' },
{ uic: '87543207', name: 'Avenue du Président Kennedy Maison de Radio France' },
{ uic: '87328328', name: 'Bibliothèque François Mitterrand' },
{ uic: '87597005', name: 'Châteauroux' },
{ uic: '87116111', name: 'Chelles - Gournay' },
{ uic: '87381087', name: 'Colombes' },
{ uic: '87697342', name: 'Dugny - La Courneuve' },
{ uic: '87281899', name: 'Haussmann Saint-Lazare' },
{ uic: '87393033', name: 'Invalides' },
{ uic: '87393066', name: 'Javel' },
{ uic: '87382432', name: 'La Celle-Saint-Cloud' },
{ uic: '87381095', name: 'Le Stade' },
{ uic: '87762906', name: 'Lyon Saint-Exupéry TGV' },
{ uic: '87281873', name: 'Magenta' },
{ uic: '87393579', name: 'Massy - Palaiseau' },
{ uic: '87393702', name: 'Massy TGV' },
{ uic: '87386318', name: 'Nanterre Université' },
{ uic: '87381020', name: 'Neuilly Porte Maillot' },
{ uic: '87756353', name: 'Nice Riquier' },
{ uic: '87756254', name: 'Nice Saint-Augustin' },
{ uic: '87271486', name: 'Parc des Expositions' },
{
    uic: '87686667', name: 'Paris Bercy Bourgogne - Pays d\'Auvergne'},
{ uic: '87271163', name: 'Pierrefitte - Stains' },
{
    uic: '87393041', name: 'Pont de l\'Alma'},
{
        uic: '87546192', name: 'Pont de Rungis Aéroport d\'Orly'},
{ uic: '87393322', name: 'Pont du Garigliano - Hôpital Européen Georges Pompidou' },
{ uic: '87654798', name: 'Rosa Parks' },
{ uic: '87393223', name: 'Saint-Cyr' },
{ uic: '87271015', name: 'Saint-Denis' },
{ uic: '87393843', name: 'Saint-Quentin en Yvelines - Montigny-le-Bretonneux' },
{ uic: '87116293', name: 'Vaires - Torcy' },
{ uic: '87382267', name: 'Vaucresson' },
{ uic: '87393009', name: 'Versailles Chantiers' },
{ uic: '87382861', name: 'Versailles Rive Droite' },
{ uic: '87317362', name: 'Abbeville' },
{ uic: '87751404', name: 'Aix-en-Provence' },
{ uic: '87313072', name: 'Albert' },
{ uic: '87721266', name: 'Albigny - Neuville' },
{ uic: '87182238', name: 'Altkirch' },
{ uic: '87743716', name: 'Ambérieu-en-Bugey' },
{ uic: '87582668', name: 'Arcachon' },
{ uic: '87753657', name: 'Arles' },
{ uic: '87751750', name: 'Aubagne' },
{ uic: '87286179', name: 'Bailleul' },
{ uic: '87755223', name: 'Bandol' },
{ uic: '87444067', name: 'Bayeux' },
{ uic: '87574160', name: 'Beaugency' },
{ uic: '87313510', name: 'Beauvais' },
{ uic: '87214122', name: 'Benfeld' },
{ uic: '87444299', name: 'Bernay' },
{ uic: '87342006', name: 'Béthune' },
{ uic: '87723544', name: 'Beynost' },
{ uic: '87582478', name: 'Biganos Facture' },
{ uic: '87317586', name: 'Boulogne' },
{ uic: '87723429', name: 'Bourgoin-Jallieu' },
{ uic: '87747451', name: 'Brignoud' },
{ uic: '87212134', name: 'Brumath' },
{ uic: '87447243', name: 'Carentan' },
{ uic: '87581538', name: 'Caudéran Mérignac' },
{ uic: '87276113', name: 'Chantilly - Gouvieux' },
{ uic: '87722561', name: 'Chasse-sur-Rhône' },
{ uic: '87142000', name: 'Chaumont' },
{
    uic: '87313304', name: 'Clermont de l\'Oise'},
{ uic: '87182014', name: 'Colmar' },
{ uic: '87396309', name: 'Connerré - Beillé' },
{ uic: '87447110', name: 'Coutances' },
{ uic: '87415018', name: 'Dieppe' },
{ uic: '87478073', name: 'Dol-de-Bretagne' },
{ uic: '87345165', name: 'Dourges' },
{ uic: '87281006', name: 'Dunkerque' },
{ uic: '87281113', name: 'Esquelbecq' },
{ uic: '87317065', name: 'Étaples - Le Touquet' },
{ uic: '87747477', name: 'Goncelin' },
{ uic: '87447680', name: 'Granville' },
{ uic: '87757724', name: 'Grasse' },
{ uic: '87582619', name: 'Gujan-Mestras' },
{ uic: '87286302', name: 'Hazebrouck' },
{ uic: '87677005', name: 'Hendaye' },
{ uic: '87345157', name: 'Hénin-Beaumont' },
{ uic: '87755629', name: 'Hyères' },
{ uic: '87734202', name: 'Issoire' },
{ uic: '87471334', name: 'Janzé' },
{ uic: '87757666', name: 'Juan les Pins' },
{
    uic: '87444638', name: 'L\'Aigle'},
{ uic: '87765479', name: 'L\'Isle - sur - la - Sorgue - Fontaine - de - Vaucluse'},
{ uic: '87751784', name: 'La Ciotat' },
{ uic: '87543124', name: 'La Ferté-Saint-Aubin' },
{ uic: '87474221', name: 'La Forest-Landerneau' },
{ uic: '87485003', name: 'La Rochelle' },
{ uic: '87582643', name: 'La Teste' },
{ uic: '87723577', name: 'La Valbonne' },
{ uic: '87417501', name: 'Lancey' },
{ uic: '87474239', name: 'Landerneau' },
{ uic: '87296012', name: 'Laon' },
{ uic: '87582601', name: 'Le Teich' },
{ uic: '87755447', name: 'Les Arcs - Draguignan' },
{ uic: '87276212', name: 'Liancourt - Rantigny' },
{ uic: '87584052', name: 'Libourne' },
{ uic: '87194001', name: 'Longwy' },
{ uic: '87141150', name: 'Lunéville' },
{ uic: '87725689', name: 'Mâcon' },
{ uic: '87191106', name: 'Maizières-lès-Metz' },
{ uic: '87582445', name: 'Marcheprime' },
{ uic: '87444208', name: 'Mézidon - Canon' },
{ uic: '87723528', name: 'Miribel' },
{ uic: '87214577', name: 'Molsheim' },
{ uic: '87396291', name: 'Montfort-le-Gesnois' },
{ uic: '87684100', name: 'Montigny-sur-Loing' },
{ uic: '87723569', name: 'Montluel' },
{ uic: '87718833', name: 'Mouchard' },
{ uic: '87696328', name: 'Moulins sur Allier' },
{ uic: '87595512', name: 'Niversac' },
{ uic: '87471540', name: 'Noyal - Acigné' },
{ uic: '87276782', name: 'Noyon' },
{ uic: '87214288', name: 'Obernai' },
{ uic: '87411207', name: 'Oissel' },
{ uic: '87546200', name: 'Orly Ville' },
{ uic: '87192468', name: 'Pagny-sur-Moselle' },
{ uic: '87595009', name: 'Perigueux' },
{ uic: '87141820', name: 'Pont-à-Mousson' },
{ uic: '87721464', name: 'Pontcharra - Saint-Forgeux' },
{ uic: '87476457', name: 'Quiberon' },
{ uic: '87476317', name: 'Quimperlé' },
{ uic: '87595223', name: 'Razac' },
{ uic: '87734053', name: 'Riom - Châtel-Guyon' },
{ uic: '87118158', name: 'Romilly-sur-Seine' },
{ uic: '87723494', name: 'Saint-André-le-Gaz' },
{ uic: '87755215', name: 'Saint-Cyr Les Lecques - La Cadière' },
{ uic: '87144014', name: 'Saint-Dié-des-Vosges' },
{
    uic: '87721282', name: 'Saint-Germain-au-Mont-d\'Or'},
{ uic: '87447003', name: 'Saint-Lô' },
{ uic: '87182139', name: 'Saint-Louis' },
{ uic: '87478107', name: 'Saint-Malo' },
{ uic: '87723353', name: 'Saint-Priest' },
{ uic: '87575050', name: 'Sainte-Maure - Noyant' },
{ uic: '87723700', name: 'Sathonay - Rillieux' },
{ uic: '87214056', name: 'Sélestat' },
{ uic: '87471532', name: 'Servon' },
{ uic: '87271817', name: 'Soissons' },
{ uic: '87765206', name: 'Sorgues - Châteauneuf-du-Pape' },
{ uic: '87296442', name: 'Tergnier' },
{ uic: '87191007', name: 'Thionville' },
{ uic: '87118000', name: 'Troyes' },
{ uic: '87191130', name: 'Uckange' },
{ uic: '87761007', name: 'Valence' },
{ uic: '87447284', name: 'Valognes' },
{ uic: '87393595', name: 'Verneuil-sur-Avre' },
{ uic: '87732008', name: 'Vichy' },
{ uic: '87756304', name: 'Villeneuve-Loubet' },
{ uic: '87471508', name: 'Vitré' }
].sort((a, b) => a.name.localeCompare(b.name));

const Select = styled('select', {
    base: {
        border: '1px solid',
        borderRadius: 'md',
        borderColor: 'gray.200',
        background: 'white',
        padding: '8px',
        margin: '8px 0',
        width: '100%',

        _focus: {
            outline: 'none',
            borderColor: 'blue.500',
            boxShadow: '0 0 0 2px var(--shadow-color)',
            boxShadowColor: 'blue.400',
        }
    }
});

const DownloadButton = styled('button', {
    base: {
        background: 'blue.500',
        color: 'white',
        textAlign: 'center',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2',
        transition: 'background 0.2s ease-in-out',

        _hover: {
            background: 'blue.600',
        },

        _focus: {
            outline: 'none',
            boxShadow: '0 0 0 2px var(--shadow-color)',
            boxShadowColor: 'blue.400',
        },

        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed',
            _hover: {
                background: 'blue.500',
            }
        }
    }
});

const TextHeading = styled('h1', {
    base: {
        fontSize: '24px',
        fontWeight: 'bold',
        margin: '16px 0',
    }
});

const Input = styled('input', {
    base: {
        border: '1px solid',
        borderRadius: 'md',
        borderColor: 'gray.200',
        background: 'white',
        padding: '8px',
        margin: '8px 0',
        width: '100%',

        _focus: {
            outline: 'none',
            borderColor: 'blue.500',
            boxShadow: '0 0 0 2px var(--shadow-color)',
            boxShadowColor: 'blue.400',
        }
    }
});

const SearchContainer = styled('div', {
    base: {
        position: 'relative',
        width: '100%',
    }
});

const SearchIcon = styled('div', {
    base: {
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: 'gray.400',
        pointerEvents: 'none',
    }
});

const App = () => {
    const [selectedUIC, setSelectedUIC] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const filteredStations = useMemo(() => {
        if (!searchQuery) return UIC_OPTIONS;
        
        const query = searchQuery.toLowerCase();
        return UIC_OPTIONS.filter(station => 
            station.name.toLowerCase().includes(query) || 
            station.uic.includes(query)
        );
    }, [searchQuery]);

    // Auto-select when there's only one result
    useEffect(() => {
        if (filteredStations.length === 1) {
            setSelectedUIC(filteredStations[0].uic);
        } else if (searchQuery && filteredStations.length === 0) {
            setSelectedUIC('');
        }
    }, [filteredStations, searchQuery]);

    const handleDownload = async () => {
        if (!selectedUIC) return;
        
        setIsLoading(true);
        try {
            const query = `
                rel[public_transport=stop_area]["ref:FR:uic8"="${selectedUIC}"]->.sa;
                way(r.sa)[public_transport=station];
                map_to_area -> .emprise;
                (
                    .emprise;
                    wr[building=train_station](area.emprise);
                    wr[indoor~"^(area|room|corridor|wall)$"](area.emprise);
                    wr[indoor][indoor!=yes](area.emprise);
                    wr[barrier=gate](area.emprise);
                    wr[ramp=yes](area.emprise);
                    wr[railway=rail](area.emprise);
                    wr[railway=platform](area.emprise);
                    node[barrier=turnstile](area.emprise);
                    wr[barrier=fence](area.emprise);
                    node[railway=stop](area.emprise);
                    wr[stairs=yes](area.emprise);
                    wr[highway=steps](area.emprise);
                );
                out geom;
            `;

            const response = await fetch('https://overpass-api.de/api/interpreter', {
                method: 'POST',
                body: query,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const xmlData = await response.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlData, 'text/xml');
            const geojsonData = osmtogeojson(xmlDoc);

            const blob = new Blob([JSON.stringify(geojsonData)], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `station_${selectedUIC}.geojson`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            toast.success('GeoJSON file downloaded successfully!');
        } catch (error) {
            console.error('Error downloading data:', error);
            toast.error('Error downloading data. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Container maxW="xl">
                <Flex direction="column" gap="4">
                    <TextHeading>Export UIC geojson</TextHeading>
                    <Flex direction="column" gap="2">
                        <label htmlFor="station-search">Rechercher une gare:</label>
                        <SearchContainer>
                            <Input
                                id="station-search"
                                type="text"
                                placeholder="Rechercher par nom ou UIC..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <SearchIcon>
                                <LuSearch size={20} />
                            </SearchIcon>
                        </SearchContainer>
                        <label htmlFor="station-select">Sélectionner une gare:</label>
                        <Select 
                            id="station-select"
                            value={selectedUIC}
                            onChange={(e) => setSelectedUIC(e.target.value)}
                        >
                            <option disabled value="">Sélectionner une gare</option>
                            {filteredStations.map(option => (
                                <option key={option.uic} value={option.uic}>
                                    {option.name} (uic: {option.uic})
                                </option>
                            ))}
                        </Select>
                        <DownloadButton 
                            onClick={handleDownload}
                            disabled={!selectedUIC || isLoading}
                        >
                            {isLoading ? 'Téléchargement...' : 'Télécharger le GeoJSON'}
                            <LuDownload />
                        </DownloadButton>
                    </Flex>
                </Flex>
            </Container>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: '#333',
                        color: '#fff',
                    },
                }}
            />
        </>
    );
};

export default App;